import styled from 'styled-components/macro';
import autobg from 'autobg.macro';
import vw from 'rpf/un/vw';
import SafeArea from 'components/SafeArea';

export const Logo = styled.div`
  ${autobg('assets/img/loading/logo.png')}
`;

export const Progress = styled.div`
  width: ${vw(287)};
  height: ${vw(11)};
  margin: ${vw(38)} 0 ${vw(39)};
  background-color: #ededed;
  border-radius: ${vw(16)};
`;

export const ProgressBar = styled.div`
  width: 0%;
  height: 100%;
  background-color: #b50029;
  border-radius: ${vw(16)};
`;

export const Text = styled.div`
  width: ${vw(82)};
  height: ${vw(26)};
  color: #989898;
  font-size: ${vw(24)};
  white-space: nowrap;
  line-height: 1;
`;

export const LoadingSafeArea = styled(SafeArea)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
